import React, { Component } from "react";
import AppContext from "../../appContext";
import CustomButton from "../../components/buttons/button";
import Swal from "sweetalert2";
import { swalOnOpen } from "../../shared/utils/swal-animations";
import { Redirect } from "react-router";
import moment from "moment";
import { confirmarPedidoEmNomeCliente } from "../../Functions/account-data/confirm-order-on-behalf";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import { montarProdutosPayload } from "../utils/montar-produtos-payload";
import "./../lente-pronta.css";

class LenteProntaEtapaCinco extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectConfirmed: false,
      confirmedData: null,
    };

    LenteProntaEtapaCinco.contextType = AppContext;
    this.confirmarPedido = this.confirmarPedido.bind(this);
  }

  confirmarPedidoEmNome = async () => {
    const confirmado = await confirmarPedidoEmNomeCliente(this.props.dados_empresa_faturamento_cnpj);
    if (confirmado) {
      this.confirmarPedido();
    }
  }

  highlightField(id) {
    const el = document.getElementById(id);
    if (el) {
      el.style.boxShadow = "0 0 0 1px #f70017";
      el.style.borderRadius = "5px";
    }
  }

  confirmarPedido() {
    this.context.showLoading("Enviando pedido...");

    let body = {
      idPedidoOtica: this.props.pedidoOtica,
      observacao: this.props.observacao || "",
      produtos: montarProdutosPayload(this.props.produtos, this.props.rpl),
      vendedor: {
        nome: this.context.userSession.nome + " " + this.context.userSession.sobrenome,
        cpf: this.context.userSession.cpf,
      },
    };

    if (this.props.codigoParticipante) {
      body.programaLaboratorio = { codigoParticipante: this.props.codigoParticipante };
    }

    if (this.props.pacto?.useVoucher && this.props.pacto?.selectedVoucher) {
      body.cortesia = {
        voucher: this.props.pacto.selectedVoucher.id,
        codigoVoucher: this.props.pacto.selectedVoucher.codigo,
      };
    }

    let headers = {
      "Content-Type": "application/json",
      access_token: sessionStorage.getItem("token"),
      laboratorio: this.props.labCnpj,
    };

    const hasSimulacaoLab = this.context.userSession.modulos.includes("Pedido e Simulação Laboratórios");
    if (
      (this.props?.redes?.length > 0 && this.context.userSession.redeOticas) ||
      this.context.userSession.papelCategoria === "ESSILOR" ||
      hasSimulacaoLab
    ) {
      headers.otica = this.props?.dados_empresa_faturamento_cnpj;
    }

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    };

    fetch(`${process.env.REACT_APP_ESSILOR_API}gestao-pedidos-laboratorio/v1/lente-pronta/pedidos`, requestOptions)
      .then(response => {
        if (response.status === 201) {
          return response.json();
        } else if (response.status === 403) {
          return response.json().then(json => {
            this.context.hideLoading();
            const hasSimulacaoLab = this.context.userSession.modulos.includes("Pedido e Simulação Laboratórios");
            const cnpjFat = CnpjUtils.cleanCnpj(this.props.dados_empresa_faturamento_cnpj);
            const cnpjCta = CnpjUtils.cleanCnpj(this.context.userSession.conta);
            if (hasSimulacaoLab && cnpjFat !== cnpjCta) {
              Swal.fire({
                html: `Você não tem permissão para passar pedidos em nome do cliente <strong>${CnpjUtils.formatCnpj(cnpjFat)}</strong>.`,
                icon: "error",
                title: "Acesso negado",
                width: "600px",
                confirmButtonColor: "#00518b",
                customClass: { confirmButton: "x-follow-order__filter-btn" },
              });
              this.highlightField("input-empresa-faturamento-cnpj");
            } else {
              Swal.fire({
                html: json[0]?.mensagem || "Não autorizado.",
                icon: "warning",
                title: "Aviso",
                width: "600px",
                confirmButtonColor: "#00518b",
                customClass: { confirmButton: "x-follow-order__filter-btn" },
              });
            }
          });
        } else if (response.status >= 400 && response.status < 499) {
          return response.json().then(json => {
            this.context.hideLoading();
            Swal.fire({
              html: json[0]?.mensagem || "Erro ao confirmar pedido.",
              icon: "warning",
              title: "Aviso",
              width: "600px",
              confirmButtonColor: "#00518b",
              customClass: { confirmButton: "x-follow-order__filter-btn" },
            });
          });
        } else {
          this.context.hideLoading();
          Swal.fire({
            html: "Tivemos uma falha momentânea de comunicação com o laboratório.",
            icon: "error",
            width: "600px",
            confirmButtonColor: "#00518b",
            customClass: { confirmButton: "x-follow-order__filter-btn" },
          });
        }
      })
      .then(json => {
        if (json) {
          this.context.hideLoading();
          this.setState({
            redirectConfirmed: true,
            confirmedData: {
              pedido: json,
              orcamento: this.props.orcamento,
              pacto: this.props.pacto,
              labName: this.props.labName,
              labCnpj: this.props.labCnpj,
              labLogo: this.props.labLogo,
              otica: this.props.otica,
              redeOticas: this.props.redeOticas,
              empresa_faturamento: this.props.empresa_faturamento,
              dados_empresa_faturamento_cnpj: this.props.dados_empresa_faturamento_cnpj,
              produtos: this.props.produtos,
              prescricaoOlhos: this.props.prescricaoOlhos,
              prescricao_OD: this.props.prescricao_OD,
              prescricao_OE: this.props.prescricao_OE,
              observacao: this.props.observacao,
              pedidoOtica: this.props.pedidoOtica,
              codigoParticipante: this.props.codigoParticipante,
            },
          });
        }
      });
  }

  render() {
    const { orcamento } = this.props;

    if (this.state.redirectConfirmed) {
      return (
        <Redirect
          to={{
            pathname: "/confirmed-lente-pronta",
            state: this.state.confirmedData,
          }}
        />
      );
    }

    const existeValorLiquido = orcamento?.valorLiquido != undefined;
    const valor = parseFloat(orcamento?.valorLiquido || 0).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });

    const hasSimulacaoLab = this.context.userSession.modulos.includes("Pedido e Simulação Laboratórios");
    const isEssilor = this.context.userSession.papelCategoria === "ESSILOR";
    const cnpjFaturamento = CnpjUtils.cleanCnpj(this.props.dados_empresa_faturamento_cnpj);
    const cnpjConta = CnpjUtils.cleanCnpj(this.context.userSession.conta);
    const isSimulacao = isEssilor || (hasSimulacaoLab && cnpjFaturamento === cnpjConta);
    const isPedidoEmNome = hasSimulacaoLab && !isEssilor && cnpjFaturamento !== cnpjConta && cnpjFaturamento;

    return (
      <main id="confirm-order-main" className="x-confirm-order__main">
        <div className="x-confirm-order__container">
          <section className="x-confirm-order__left">
            <div className="x-confirm-order__dados--container2">
              <div className="x-confirm-order__dados--intro">
                <h1 className="x-confirm-order__dados--title">
                  {isSimulacao ? "Simulação de pedido" : "Confirme seu pedido"}
                </h1>
                <span className="x-confirm-order__dados--square"></span>
                <p className="x-confirm-order__dados--paragraph">
                  Olá, {this.context.userSession?.nome || ""}.
                </p>
                <p className="x-confirm-order__dados--paragraph">
                  {isSimulacao
                    ? (isEssilor
                        ? "Este é apenas um orçamento de simulação. Não é possível confirmar pedidos com o perfil Essilor."
                        : "Este é apenas um orçamento de simulação. Não é possível confirmar pedidos em nome do próprio laboratório.")
                    : <>Seu pedido foi validado e está pronto para ser enviado ao laboratório.<br />Revise atentamente o resumo do pedido ao lado e clique em confirmar pedido para concluí-lo.</>
                  }
                </p>
              </div>
              <div className="x-confirm-order__list">
                {existeValorLiquido && (
                  <ul className="x-confirm-order__dados--list">
                    <li className="x-confirm-order__dados--item is--large">Valor total do pedido</li>
                    <li className="x-confirm-order__dados--item blue">{valor}</li>
                  </ul>
                )}
                <ul className="x-confirm-order__dados--list">
                  <li className="x-confirm-order__dados--item is--large">Data de saída estimada</li>
                  <li className="x-confirm-order__dados--item blue">
                    {orcamento?.dataPrevistaEntrega ? moment(orcamento.dataPrevistaEntrega).format("DD/MM/YYYY") : "-"}
                  </li>
                </ul>
              </div>
              {!isSimulacao && (
                <div className="x-confirm-order__dados--intro">
                  <p className="x-confirm-order__dados--paragraph_small">
                    Ao clicar em confirmar o pedido, você concorda com o envio das informações que constam no resumo lateral e com os{" "}
                    <a id="link-termos-condicoes" href="#termos" target="_blank" rel="noopener noreferrer">
                      termos e condições de compra
                    </a>
                    .
                  </p>
                </div>
              )}
              <div className="row lente-pronta-buttons lente-pronta-buttons-confirm">
                <div className="col-md-3 col-l-3 col-s-12 lente-pronta-prev-button">
                  <CustomButton
                    id="btn-corrigir-pedido"
                    label="Corrigir"
                    width="13.125rem"
                    icon_arrow_left
                    orange_button
                    onClick={this.props.corrigirPedido}
                  />
                </div>
                {!isSimulacao && (
                  <div className="col-md-3 col-l-3 col-s-12 lente-pronta-next-button confirm">
                    <CustomButton
                      id="btn-confirmar-pedido"
                      label="Confirmar pedido"
                      width="13.125rem"
                      icon_arrow_right
                      onClick={isPedidoEmNome ? this.confirmarPedidoEmNome : this.confirmarPedido}
                    />
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </main>
    );
  }
}

export default LenteProntaEtapaCinco;
